/**
 * Created by PanJiaChen on 16/11/18.
 */

import store from "../store"
import {getMaskStatus} from '../utils/auth'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function formatTimer(msTime) {
  let time = msTime / 1000;

  // let hour = Math.floor(time / 60 / 60);

  // hour = hour.toString().padStart(2, "0");

  let minute = Math.floor(time / 60) % 60;

  minute = minute.toString().padStart(2, "0");

  let second = Math.floor(time) % 60;

  second = second.toString().padStart(2, "0");

  return `${minute}分${second}秒`;
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}
// format money
function numFormat(num) {
  let integer = num.toString().split('.')[0]
  const decimals = num.toString().split('.')[1]
  integer = integer.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  const result = integer + '.' + decimals
  return result
}
function fomatFloat(value, n) {
  const f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n)
  let s = f.toString()
  if (n) {
    const rs = s.indexOf('.')
    if (rs < 0) {
      s += '.'
    }
    for (var i = s.length - s.indexOf('.'); i <= n; i++) {
      s += '0'
    }
  }else{
    s = s.replace(/[^\d]/g,'')
  }
  return s
}
export function formatMoney(value, currencyId) {
  const currency = store.state.app.commonData.currency
  // if (currency) {
    const minorUnitArr = currency ? currency.filter(_ => _.code === currencyId) : [{ minorUnit:2 }]
    const decimalplaces = minorUnitArr.length > 0 ? minorUnitArr[0].minorUnit : 2
    return numFormat(fomatFloat(value, decimalplaces))
  // }
}
export function formatMoneyValue(value, n = 2) {
  if (value || value === 0) {
    if (n){
      return numFormat(fomatFloat(value, n))
    }else{
      return fomatFloat(value, n)
    }
  }else {
    return value
  }
}
export function StrToNumber(obj) {
  if (obj) {
    let reg = /^[0-9]+.?[0-9]*$/;  //验证字符串是否是数字
    if (!(reg.test(obj))) {
      //为字符串 则判断是否存在','
      if((obj + "").replace(/^\s\s*/, '').replace(/\s\s*$/, '') === ""){
        return 0.00 
      }
      if(obj === undefined){
        return 0.00
      }
      if((obj || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')){
        obj = obj.replace(/,/gi, '')
        return obj
      }
    }
    return obj
  }
}

export function toEmptyObj(obj) {
  Object.keys(obj).forEach(key=>{obj[key]=''})
}
export function EncryptedMobile(mobile) {
  const reg = /^(\d{3})\d*(\d{4})$/;
  return mobile.replace(reg,'$1****$2')
}
export function validMoney(e, type) {
  if (type && type === 'noDecimal') {
    e.target.value = e.target.value.replace(/[^\d]/g,'')
  } else {
    e.target.value = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g,'$1')
  }
}
export function validMoneyValue(e, type) {
  if (type && type === 'noDecimal') {
    e = e.toString().replace(/[^\d]/g,'')
  } else {
    e = e.toString().replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g,'$1')
  }
  return e
}
//掩码替换
export function changeToMask(data, type){
  if (!data){
    return data
  }
  let status = getMaskStatus()
  if (status === 'off'){
    return data
  }
  let newData = ''
  switch (type) {
    case 'name':
      newData = maskName(data)
      break
    case 'idCard': {
      newData = plusXing(data, 5, 2)
      break
    }
    case 'bankNo': {
      newData = plusXing(data, 2, 2)
      break
    }
    case 'mobile': {
      newData = plusXing(data, 3, 4)
      break
    }
    case 'number': {
      newData = plusXing(data, 0, 2)
      break
    }
    default:
      newData = data
  }
  return newData
}
//名称加掩码
function maskName(str){
  var len = str.length
  var endLen = 0
  if (str.charCodeAt(len-1)>=127){
    endLen = 1
  }else{
    endLen = 2
  }
  return plusXing(str, 0, endLen)
}
//根据条件转换掩码字符
function plusXing(str, frontLen, endLen) {
  let len = str.length - frontLen - endLen;
  let xing = '';
  for (let i = 0; i < len; i++) {
    xing += '*';
  }
  if (len < 1){
    return str
  }else{
    return str.substring(0,frontLen) + xing + str.substring(str.length - endLen);
  }
}
export function getCurrentTime() {
  //获取当前时间并打印
  var _this = this;
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth()+1;
  let dd = new Date().getDate();
  let hh = new Date().getHours();
  let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
  return yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
}